import React, { useCallback } from 'react';
import { Button, ButtonDescription, Icon } from '@vp/swan';
import { LOCALIZED_URLS } from 'src/constants';
import { useProductContext } from 'src/hooks/ProductContextHooks';
import { useTrackingContext } from 'src/hooks/TrackingContextHooks';
import { usePerfectBound } from 'src/hooks/usePerfectBound';
import { useIsPdfOnly } from 'src/hooks/ValidationContextHooks';
import { UPLOAD_UNIFIED_EVENT, UploadSteps } from 'src/utils/Constants';
import { getLanguage, text } from 'src/utils/localizationUtil';
import { createTrackingDataForProduct } from 'src/utils/trackingUtil';
import { AnalyticsEventData, sendEventTracking } from '../Analytics';

interface Props {
  isMobile: boolean;
}

export const PrintGuidelinesButton = ({ isMobile }: Props) => {
  const { productInformation } = useProductContext();
  const { trackingConfiguration } = useTrackingContext();
  const { isPerfectBound } = usePerfectBound();

  const lng = getLanguage();
  const printGuidelinesPDFURL = isPerfectBound ? '' : LOCALIZED_URLS[lng];

  // This is not the best logic to determine if this is a booklets product, but it should work for now
  const isBooklet = useIsPdfOnly();

  const openUrl = (url: string) => {
    window.open(url, '_blank');
  };

  const handlePrintGuidelinesClick = useCallback(() => {
    if (printGuidelinesPDFURL) {
      sendEventTracking({
        ...trackingConfiguration,
        ...createTrackingDataForProduct(productInformation),
        action: UPLOAD_UNIFIED_EVENT,
        label: 'Print Guidelines',
        fileType: 'pdf',
        category: 'Design - Upload and Print',
        uploadStep: UploadSteps.TemplateDownloaded,
        variant: JSON.stringify(productInformation.selectedOptions),
      } as AnalyticsEventData);
      openUrl(printGuidelinesPDFURL);
    }
  }, [printGuidelinesPDFURL, productInformation, trackingConfiguration]);

  if (!printGuidelinesPDFURL || !isBooklet) {
    return null;
  }

  return (
    <Button
      width="full-width"
      specialVariant="design-path"
      marginY={isMobile ? '5' : '7'}
      component="a"
      onClick={handlePrintGuidelinesClick}
    >
      <Icon iconType="arrowRight" />
      {text('print-guidelines')}
      <ButtonDescription>{text('print-guidelines-desc')}</ButtonDescription>
    </Button>
  );
};
